module.exports = __webpack_public_path__ + "static/media/logo-brios.f6a5859a.webp";